import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const reportG5 = {
    getAmountReport,
    getServiceProportion
};

function getAmountReport(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG5/getAmountReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}
function getServiceProportion(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG5/getServiceProportion/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}